import {
  FileCodeIcon,
  FileMdIcon,
  FilePyIcon,
  FileSqlIcon,
  FileText,
  TerminalIcon,
} from '@/lib/icons';

export function getFileIcon(filename: string) {
  const ext = filename.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'py': return FilePyIcon;
    case 'md': return FileMdIcon;
    case 'sql': return FileSqlIcon;
    case 'js': case 'ts': case 'jsx': case 'tsx': return FileCodeIcon;
    case 'sh': case 'bash': return TerminalIcon;
    default: return FileText;
  }
}
